import React, { useEffect, useState } from "react";
import { Grid, Button, makeStyles, TextField } from "@material-ui/core";
import { Link } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import { Pagination } from "react-bootstrap";
import { ProgressBar } from "react-bootstrap";
import Moment from "moment";
import {
	getMain,
	getBotWeeklyResult,
	getBotScheduleResult,
	findLoginId,
	getMainSys,
} from "../modules/api";
import { Line } from "react-chartjs-2";

const useStyles = makeStyles((theme) => ({
	container: {
		display: "flex",
		flexWrap: "wrap",
	},
	textField: {
		marginLeft: theme.spacing(1),
		marginRight: theme.spacing(1),
		width: 200,
	},
}));

export function BotMain() {
	const classes = useStyles();
	// The first commit of Material-UI
	const [todayTotalExeCount, setTodayTotalExeCount] = useState();
	const [todayTotalExeSuccessCount, setTodayTotalExeSuccessCount] = useState();
	const [exeRate, setExeRate] = useState(0);
	const [todayScheduleList, setTodayScheduleList] = useState([]);
	const [todayScheduleListYn, setTodayScheduleListYn] = useState(false);
	const [botList, setBotList] = useState([]);
	const [botList2, setBotList2] = useState([]);
	const [botListYn, setBotListYn] = useState(false);
	const [weeklyExeStartDate, setWeeklyExeStartDate] = useState(
		Moment()
			.add(-7, "days")
			.format("YYYY-MM-DD")
	);
	const [weeklyExeEndDate, setWeeklyExeEndDate] = useState(
		Moment(new Date()).format("YYYY-MM-DD")
	);
	const [weeklyScheduleStartDate, setWeeklyScheduleStartDate] = useState(
		Moment()
			.add(-7, "days")
			.format("YYYY-MM-DD")
	);
	const [weeklyScheduleEndDate, setWeeklyScheduleEndDate] = useState(
		Moment(new Date()).format("YYYY-MM-DD")
	);

	const [weeklyDateList, setWeeklyDateList] = useState([]);
	const [weeklyTotalCnt, setWeeklyTotalCnt] = useState([]);
	const [weeklySuccCnt, setWeeklySuccCnt] = useState([]);
	const [weeklyFailCnt, setWeeklyFailCnt] = useState([]);
	const [weeklyExeYn, setWeeklyExeYn] = useState(false);

	const [realTimeDateList, setRealTimeDateList] = useState([]);
	const [realTimeTotalCnt, setRealTimeTotalCnt] = useState([]);
	const [realTimeSuccCnt, setRealTimeSuccCnt] = useState([]);
	const [realTimeFailCnt, setRealTimeFailCnt] = useState([]);
	const [realTimeExeYn, setRealTimeExeYn] = useState(false);

	const [weeklyScheduleDateList, setWeeklyScheduleDateList] = useState([]);
	const [weeklyScheduleTotalCnt, setWeeklyScheduleTotalCnt] = useState([]);
	const [weeklyScheduleSuccCnt, setWeeklyScheduleSuccCnt] = useState([]);
	const [weeklyScheduleFailCnt, setWeeklyScheduleFailCnt] = useState([]);
	const [weeklyScheduleYn, setWeeklyScheduleYn] = useState(false);
	const [botAdminList, setBotAdminList] = useState([]);

	const fetchData = async (value) => {
		try {
			const role = localStorage.getItem("userRole");
			console.log("role", role);
			// const result = await getMain();
			let result;
			if (role === "SystemAdmin") {
				result = await getMainSys(value);
				const botAdminList = await findLoginId();
				setBotAdminList(botAdminList.data);
			} else {
				result = await getMain();
			}
			console.log("getMain", result);

			setTodayTotalExeCount(
				result.todayTotalExeCount ? result.todayTotalExeCount : 0
			);
			setTodayTotalExeSuccessCount(result.todayTotalExeSuccessCount);
			setExeRate(
				(parseInt(result.todayTotalExeSuccessCount) /
					parseInt(result.todayTotalExeCount)) *
					100
			);

			let scheduleList;
			if (result.todayScheduleList.length === 0) {
				setTodayScheduleListYn(true);
				setTodayScheduleList([]);
			} else {
				if (result.todayScheduleList.length < 8) {
					setTodayScheduleList(result.todayScheduleList);
				} else {
					for (let i = 0; i < 7; i++) {
						scheduleList.push(result.todayScheduleList[i]);
					}
					setTodayScheduleList(scheduleList);
				}
				setTodayScheduleListYn(false);
			}

			let bot = [];
			if (result.botList.length === 0) {
				setBotListYn(true);
			} else {
				if (result.botList.length < 7) {
					setBotList(result.botList);
				} else {
					for (let i = 0; i < 6; i++) {
						bot.push(result.botList[i]);
					}
					setBotList(bot);
				}
				setBotListYn(false);
			}

			//기간 별 실행 결과 현황
			if (result.weeklyExeCount.length > 0) {
				let weeklyDateList = [];
				let weeklySuccCnt = [];
				let weeklyTotalCnt = [];
				let weeklyFailCnt = [];
				result.weeklyExeCount.map((data, index) => {
					weeklyDateList.push(data.execDate.substring(8, 10));
					weeklyTotalCnt.push(data.execCnt);
					weeklySuccCnt.push(data.successCnt);
					weeklyFailCnt.push(data.failCnt);
				});
				setWeeklyDateList(weeklyDateList);
				setWeeklyTotalCnt(weeklyTotalCnt);
				setWeeklySuccCnt(weeklySuccCnt);
				setWeeklyFailCnt(weeklyFailCnt);
				setWeeklyExeYn(true);
			} else {
				setWeeklyExeYn(false);
			}

			//실시간 실행 결과 현황

			if (result.todayExeCountByHour.length > 0) {
				let realTimeDateList = [];
				let realTimeSuccCnt = [];
				let realTimeTotalCnt = [];
				let realTimeFailCnt = [];
				result.todayExeCountByHour.map((data, index) => {
					realTimeDateList.push(data.execDate);
					realTimeTotalCnt.push(data.execCnt);
					realTimeSuccCnt.push(data.successCnt);
					realTimeFailCnt.push(data.failCnt);
				});
				setRealTimeDateList(realTimeDateList);
				setRealTimeTotalCnt(realTimeTotalCnt);
				setRealTimeSuccCnt(realTimeSuccCnt);
				setRealTimeFailCnt(realTimeFailCnt);
				setRealTimeExeYn(true);
			} else {
				setRealTimeExeYn(false);
			}

			//기간 별 예약 실행 결과 현황
			if (result.weeklyScheduleExeCount.length > 0) {
				let weeklyScheduleDateList = [];
				let weeklyScheduleSuccCnt = [];
				let weeklyScheduleTotalCnt = [];
				let weeklyScheduleFailCnt = [];
				result.weeklyScheduleExeCount.map((data, index) => {
					weeklyScheduleDateList.push(data.execDate.substring(8, 10));
					weeklyScheduleTotalCnt.push(data.execCnt);
					weeklyScheduleSuccCnt.push(data.successCnt);
					weeklyScheduleFailCnt.push(data.failCnt);
				});
				setWeeklyScheduleDateList(weeklyScheduleDateList);
				setWeeklyScheduleTotalCnt(weeklyScheduleTotalCnt);
				setWeeklyScheduleSuccCnt(weeklyScheduleSuccCnt);
				setWeeklyScheduleFailCnt(weeklyScheduleFailCnt);
				setWeeklyScheduleYn(true);
			} else {
				setWeeklyScheduleYn(false);
			}
		} catch (e) {
			console.log(e);
			// Handle error
		}
	};

	useEffect(() => {
		// setListLoading(true);
		// setTimeout(async () => {
		fetchData();
		// 	setListLoading(false);
		// }, 1000);
	}, []);

	const getWeekly = async () => {
		const res = await getBotWeeklyResult(weeklyExeStartDate, weeklyExeEndDate);
		// console.log("getBotWeeklyResult", res);
		if (res.weeklyExeCount.length > 0) {
			let weeklyDateList = [];
			let weeklySuccCnt = [];
			let weeklyTotalCnt = [];
			let weeklyFailCnt = [];
			res.weeklyExeCount.map((data, index) => {
				weeklyDateList.push(data.execDate.substring(8, 10));
				weeklyTotalCnt.push(data.execCnt);
				weeklySuccCnt.push(data.successCnt);
				weeklyFailCnt.push(data.failCnt);
			});
			setWeeklyDateList(weeklyDateList);
			setWeeklyTotalCnt(weeklyTotalCnt);
			setWeeklySuccCnt(weeklySuccCnt);
			setWeeklyFailCnt(weeklyFailCnt);
			setWeeklyExeYn(true);
		} else {
			setWeeklyExeYn(false);
		}
	};

	const getSchedule = async () => {
		const res = await getBotScheduleResult(
			weeklyScheduleStartDate,
			weeklyScheduleEndDate
		);

		if (res.weeklyScheduleExeCount.length > 0) {
			let weeklyScheduleDateList = [];
			let weeklyScheduleSuccCnt = [];
			let weeklyScheduleTotalCnt = [];
			let weeklyScheduleFailCnt = [];
			res.weeklyScheduleExeCount.map((data, index) => {
				weeklyScheduleDateList.push(data.execDate.substring(8, 10));
				weeklyScheduleTotalCnt.push(data.execCnt);
				weeklyScheduleSuccCnt.push(data.successCnt);
				weeklyScheduleFailCnt.push(data.failCnt);
			});
			setWeeklyScheduleDateList(weeklyScheduleDateList);
			setWeeklyScheduleTotalCnt(weeklyScheduleTotalCnt);
			setWeeklyScheduleSuccCnt(weeklyScheduleSuccCnt);
			setWeeklyScheduleFailCnt(weeklyScheduleFailCnt);
			setWeeklyScheduleYn(true);
		} else {
			setWeeklyScheduleYn(false);
		}
	};

	const handleWeeklyStartDateChange = (e) => {
		setWeeklyExeStartDate(e.target.value);
	};
	const handleWeeklyEndDateChange = (e) => {
		setWeeklyExeEndDate(e.target.value);
	};
	const handleScheduleStartDateChange = (e) => {
		setWeeklyScheduleStartDate(e.target.value);
	};
	const handleScheduleEndDateChange = (e) => {
		setWeeklyScheduleEndDate(e.target.value);
	};

	const toDoList = todayScheduleList.map((data, index) => {
		// console.log("data", data);
		return (
			<tr>
				<td className="text-left">
					예약시간{" "}
					{data.startTime.substring(0, 2) + ":" + data.startTime.substring(2)}
				</td>
				<td>{data.scheduleName}</td>
				<td className="text-right">
					<span className="label label-xl label-inline label-success">
						성공
					</span>
				</td>
			</tr>
		);
	});

	const botRate = botList.map((data, index) => {
		let exeRate = (data.botExeCnt / data.allExeCnt) * 100;
		return (
			<li className="mb-5">
				<div className="d-flex align-items-center justify-content-between mb-2">
					<p className="mb-0 text-left">{data.name}</p>
					<small className="mb-1 d-flex text-gray">
						{Math.round(isNaN(exeRate) ? 0 : exeRate)}%({data.botExeCnt}/
						{data.allExeCnt === null ? 0 : data.allExeCnt})
					</small>
				</div>
				<div className="progress-wrap d-flex align-items-center justify-content-between">
					<div className="progress progress-xs w-100">
						<div
							className="progress-bar bg-danger"
							role="progressbar"
							style={{ width: Math.round(isNaN(exeRate) ? 0 : exeRate) }}
							aria-valuenow={data.botExeCnt}
							aria-valuemin="0"
							aria-valuemax={data.allExeCnt}
						></div>
					</div>
				</div>
			</li>
		);
	});

	return (
		<div>
			<div
				className="d-flex align-items-center justify-content-between w-100"
				style={{ marginTop: 30 }}
			>
				<h3 className="card-label font-weight-bolder text-dark d-flex align-items-center mb-0">
					대시보드
				</h3>
				{localStorage.getItem("userRole") === "SystemAdmin" && (
					<div className="fv-plugins-icon-container mr-5">
						<select
							className="form-control form-control-lg form-control-solid"
							style={{ borderColor: "black", width: "200px" }}
							name="botAdminList"
							onChange={(e) => fetchData(e.target.value)}
						>
							<option value="">선택</option>
							{botAdminList &&
								botAdminList.length > 0 &&
								botAdminList.map((data, index) => {
									return <option value={data.no}>{data.loginId}</option>;
								})}
						</select>
					</div>
				)}
			</div>
			<div id="pageid22" style={{ marginTop: 50 }}>
				<div className="row dashboard-top-btn-row justify-content-between">
					<div className="col-xl-3 gutter-b">
						<Link href="/PageId30">
							<Button
								className={`btn font-weight-bold text-white px-9 py-7 w-100 justify-content-between`}
							>
								<div className="text text-left">
									<h1>{todayTotalExeCount}</h1>
									<h6 className="mb-0">실행건수</h6>
								</div>
								<div className="icon">
									<span className="svg-icon svg-icon-xxl">
										<SVG
											src={toAbsoluteUrl("/media/svg/icons/Home/Book.svg")}
										/>
									</span>
								</div>
							</Button>
						</Link>
					</div>
					<div className="col-xl-3 gutter-b">
						<Link href="/PageId30">
							<Button
								className={`btn font-weight-bold text-white px-9 py-7 w-100 justify-content-between`}
							>
								<div className="text text-left">
									<h1>{Math.round(isNaN(exeRate) ? 0 : exeRate)}</h1>
									<h6 className="mb-0">실행 성공률</h6>
								</div>
								<div className="icon">
									<span className="svg-icon svg-icon-xxl">
										<SVG
											src={toAbsoluteUrl(
												"/media/svg/icons/Navigation/Angle-double-right.svg"
											)}
										/>
									</span>
								</div>
							</Button>
						</Link>
					</div>
					<div className="col-xl-3 gutter-b">
						<Link href="/PageId25">
							<Button
								className={`btn font-weight-bold text-white px-9 py-7 w-100 justify-content-between`}
							>
								<div className="text text-left">
									<h1>{todayScheduleList.length}</h1>
									<h6 className="mb-0">예약건수</h6>
								</div>
								<div className="icon">
									<span className="svg-icon svg-icon-xxl">
										<SVG
											src={toAbsoluteUrl(
												"/media/svg/icons/Communication/Write.svg"
											)}
										/>
									</span>
								</div>
							</Button>
						</Link>
					</div>
				</div>
				<div className="row">
					<div className="col-xl-4">
						<div className="card card-custom gutter-b card-stretch">
							<div className="card-header border-0 pt-5">
								<h3 className="card-label font-weight-bolder text-dark d-flex align-items-center mb-0">
									현재 Bot 실행 현황
								</h3>
							</div>
							<div className="card-body align-items-center d-flex justify-content-center flex-column">
								<h1 className="mb-7">0/{botList2.length}</h1>
								<p>현재 {botList2.length}bot 중에 0bot이 실행중입니다.</p>
								<div className="more-info">
									<Link to="/botMonitoring" className="text-primary">
										More info
									</Link>
								</div>
							</div>
						</div>
					</div>
					<div className="col-xl-4">
						<div className="card card-custom gutter-b card-stretch">
							<div className="card-header border-0 pt-5">
								<h3 className="card-label font-weight-bolder text-dark d-flex align-items-center mb-0">
									기간 별 실행 결과 현황
								</h3>
								<p className="d-flex align-items-center mb-0">단위 : 건</p>
							</div>
							<div className="card-body align-items-center d-flex justify-content-center flex-column">
								<div className="d-flex">
									<form className={classes.container} noValidate>
										<TextField
											id="date"
											type="date"
											style={{ width: "130px" }}
											defaultValue={weeklyExeStartDate}
											onChange={(e) => handleWeeklyStartDateChange(e)}
											className={classes.textField}
											InputLabelProps={{
												shrink: true,
											}}
										/>
									</form>
									<span> ~ </span>
									<form className={classes.container} noValidate>
										<TextField
											id="date"
											type="date"
											style={{ width: "130px" }}
											defaultValue={weeklyExeEndDate}
											onChange={(e) => handleWeeklyEndDateChange(e)}
											className={classes.textField}
											InputLabelProps={{
												shrink: true,
											}}
										/>
									</form>
									<Button
										onClick={() => getWeekly()}
										style={{ marginLeft: "5px" }}
										className={`btn btn-info font-weight-bold text-white`}
									>
										검색
									</Button>
								</div>
								<div style={{ marginTop: "25px" }}>
									{!weeklyExeYn && (
										<div style={{ marginTop: "5px" }}>
											실행 내역이 없습니다.
										</div>
									)}
									{weeklyExeYn && (
										<Line
											data={{
												labels: weeklyDateList,
												datasets: [
													{
														label: "전체",
														data: weeklyTotalCnt,
														fill: false,
														backgroundColor: "rgb(192,192,192)",
														borderColor: "rgb(192,192,192)",
														tension: 0.5,
													},
													{
														label: "성공",
														data: weeklySuccCnt,
														fill: false,
														backgroundColor: "rgb(90, 181, 2)",
														borderColor: "rgb(90, 181, 2)",
														tension: 0.5,
													},
													{
														label: "실패",
														data: weeklyFailCnt,
														fill: false,
														backgroundColor: "#ff6f5e",
														borderColor: "#ff6f5e",
														tension: 0.5,
													},
												],
											}}
											height={200}
											width={350}
											options={{
												maintainAspectRatio: false,
												plugins: {
													legend: {
														position: "bottom",
													},
												},
											}}
										/>
									)}
								</div>
								<div className="more-info">
									<Link href="/PageId29" className="text-primary">
										More info
									</Link>
								</div>
							</div>
						</div>
					</div>
					<div className="col-xl-4">
						<div className="card card-custom gutter-b card-stretch">
							<div className="card-header border-0 pt-5">
								<h3 className="card-label font-weight-bolder text-dark d-flex align-items-center mb-0">
									오늘 예약 작업 리스트
								</h3>
							</div>
							<div className="card-body align-items-center d-flex justify-content-center flex-column">
								<table className="w-100 reservation-table">
									<tbody>
										{todayScheduleListYn && (
											<tr>
												<td style={{ textAlign: "center" }}>
													예약 작업이 없습니다.
												</td>
											</tr>
										)}
										{!todayScheduleListYn && toDoList}
										{/* <tr>
											<td className="text-left"> 오후 11시</td>
											<td>예약 작업1</td>
											<td className="text-right">
												<span className="disabled label label-xl label-inline label-secondary">
													미실행
												</span>
											</td>
										</tr>
										<tr>
											<td className="text-left">오후 7시</td>
											<td>예약 작업2</td>
											<td className="text-right">
												<span className="label label-xl label-inline label-success">
													성공
												</span>
											</td>
										</tr>
										<tr>
											<td className="text-left">오후 6시</td>
											<td>예약 작업3</td>
											<td className="text-right">
												<span className="label label-xl label-inline label-primary">
													실패
												</span>
											</td>
										</tr>
										<tr>
											<td className="text-left">오후 4시</td>
											<td>예약 작업4</td>
											<td className="text-right">
												<span className="label label-xl label-inline label-success">
													성공
												</span>
											</td>
										</tr>
										<tr>
											<td className="text-left">오후 3시</td>
											<td>예약 작업5</td>
											<td className="text-right">
												<span className="label label-xl label-inline label-primary">
													실패
												</span>
											</td>
										</tr>
										<tr>
											<td className="text-left">오후 1시</td>
											<td>예약 작업6</td>
											<td className="text-right">
												<span className="label label-xl label-inline label-success">
													성공
												</span>
											</td>
										</tr> */}
									</tbody>
								</table>

								<div className="more-info">
									<Link to="/schedule" className="text-primary">
										More info
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-xl-4">
						<div className="card card-custom gutter-b card-stretch">
							<div className="card-header border-0 pt-5">
								<h3 className="card-label font-weight-bolder text-dark d-flex align-items-center mb-0">
									오늘 Bot 실행률 현황
								</h3>
								<p className="d-flex align-items-center mb-0">단위 : %(건)</p>
							</div>
							<div className="card-body align-items-center d-flex justify-content-center flex-column">
								<ul className="w-100 pl-0">
									{botListYn && (
										<div style={{ textAlign: "center" }}>
											실행 내역이 없습니다.
										</div>
									)}
									{!botListYn && botRate}
									{/* <li className="mb-5">
										<p className="mb-0 text-left">logan1</p>
										<small className="mb-1 d-flex text-gray">50%(50/100)</small>
										<div className="progress-wrap d-flex align-items-center justify-content-between">
											<ProgressBar
												animated
												now={100}
												style={{ height: "10px", width: "50%" }}
											/>
										</div>
									</li>
									<li className="mb-5">
										<p className="mb-0 text-left">logan2</p>
										<small className="mb-1 d-flex text-gray">25%(25/100)</small>
										<div className="progress-wrap d-flex align-items-center justify-content-between">
											<ProgressBar
												animated
												now={100}
												style={{ height: "10px", width: "25%" }}
											/>
										</div>
									</li>
									<li className="mb-5">
										<p className="mb-0 text-left">logan3</p>
										<small className="mb-1 d-flex text-gray">10%(10/100)</small>
										<div className="progress-wrap d-flex align-items-center justify-content-between">
											<ProgressBar
												animated
												now={100}
												style={{ height: "10px", width: "10%" }}
											/>
										</div>
									</li>
									<li>
										<p className="mb-0 text-left">logan4</p>
										<small className="mb-1 d-flex text-gray">5%(5/100)</small>
										<div className="progress-wrap d-flex align-items-center justify-content-between">
											<ProgressBar
												animated
												now={100}
												style={{ height: "10px", width: "5%" }}
											/>
										</div>
									</li> */}
								</ul>
								{/* <div className="d-flex flex-center mt-5">
									<Pagination>
										<Pagination.Prev />

										<Pagination.Item>{1}</Pagination.Item>
										<Pagination.Item>{2}</Pagination.Item>
										<Pagination.Item active>{3}</Pagination.Item>
										<Pagination.Item disabled>{4}</Pagination.Item>
										<Pagination.Item>{5}</Pagination.Item>

										<Pagination.Next />
									</Pagination>
								</div> */}
								<div className="more-info">
									<Link href="/PageId24" className="text-primary">
										More info
									</Link>
								</div>
							</div>
						</div>
					</div>
					<div className="col-xl-4">
						<div className="card card-custom gutter-b card-stretch">
							<div className="card-header border-0 pt-5">
								<h3 className="card-label font-weight-bolder text-dark d-flex align-items-center mb-0">
									실시간 실행 결과 현황
								</h3>
								<p className="d-flex align-items-center mb-0">단위 : 시간</p>
							</div>
							<div className="card-body align-items-center d-flex justify-content-center flex-column">
								<div style={{ marginTop: "25px" }}>
									{!realTimeExeYn && (
										<div style={{ marginTop: "5px" }}>
											실행 내역이 없습니다.
										</div>
									)}
									{realTimeExeYn && (
										<Line
											data={{
												labels: realTimeDateList,
												datasets: [
													{
														label: "전체",
														data: realTimeTotalCnt,
														fill: false,
														backgroundColor: "rgb(192,192,192)",
														borderColor: "rgb(192,192,192)",
														tension: 0.5,
													},
													{
														label: "성공",
														data: realTimeSuccCnt,
														fill: false,
														backgroundColor: "rgb(90, 181, 2)",
														borderColor: "rgb(90, 181, 2)",
														tension: 0.5,
													},
													{
														label: "실패",
														data: realTimeFailCnt,
														fill: false,
														backgroundColor: "#ff6f5e",
														borderColor: "#ff6f5e",
														tension: 0.5,
													},
												],
											}}
											height={200}
											width={350}
											options={{
												maintainAspectRatio: false,
												plugins: {
													legend: {
														position: "bottom",
													},
												},
											}}
										/>
									)}
								</div>
								<div className="more-info">
									<Link href="/PageId30" className="text-primary">
										More info
									</Link>
								</div>
							</div>
						</div>
					</div>
					<div className="col-xl-4">
						<div className="card card-custom gutter-b card-stretch">
							<div className="card-header border-0 pt-5">
								<h3 className="card-label font-weight-bolder text-dark d-flex align-items-center mb-0">
									기간 별 예약 실행 결과 현황
								</h3>
								<p className="d-flex align-items-center mb-0">단위 : 건</p>
							</div>
							<div className="card-body align-items-center d-flex justify-content-center flex-column">
								<div className="d-flex">
									<form className={classes.container} noValidate>
										<TextField
											id="date"
											type="date"
											style={{ width: "130px" }}
											defaultValue={weeklyScheduleStartDate}
											onChange={(e) => handleScheduleStartDateChange(e)}
											className={classes.textField}
											InputLabelProps={{
												shrink: true,
											}}
										/>
									</form>
									<span> ~ </span>
									<form className={classes.container} noValidate>
										<TextField
											id="date"
											type="date"
											style={{ width: "130px" }}
											defaultValue={weeklyScheduleEndDate}
											onChange={(e) => handleScheduleEndDateChange(e)}
											className={classes.textField}
											InputLabelProps={{
												shrink: true,
											}}
										/>
									</form>
									<Button
										onClick={() => getSchedule()}
										style={{ marginLeft: "5px" }}
										className={`btn btn-info font-weight-bold text-white`}
									>
										검색
									</Button>
								</div>
								<div style={{ marginTop: "25px" }}>
									{!weeklyScheduleYn && (
										<div style={{ marginTop: "5px" }}>
											실행 내역이 없습니다.
										</div>
									)}
									{weeklyScheduleYn && (
										<Line
											data={{
												labels: weeklyScheduleDateList,
												datasets: [
													{
														label: "전체",
														data: weeklyScheduleTotalCnt,
														fill: false,
														backgroundColor: "rgb(192,192,192)",
														borderColor: "rgb(192,192,192)",
														tension: 0.5,
													},
													{
														label: "성공",
														data: weeklyScheduleSuccCnt,
														fill: false,
														backgroundColor: "rgb(90, 181, 2)",
														borderColor: "rgb(90, 181, 2)",
														tension: 0.5,
													},
													{
														label: "실패",
														data: weeklyScheduleFailCnt,
														fill: false,
														backgroundColor: "#ff6f5e",
														borderColor: "#ff6f5e",
														tension: 0.5,
													},
												],
											}}
											height={200}
											width={350}
											options={{
												maintainAspectRatio: false,
												plugins: {
													legend: {
														position: "bottom",
													},
												},
											}}
										/>
									)}
								</div>
								<div className="more-info">
									<Link href="/PageId29" className="text-primary">
										More info
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default BotMain;
